// extracted by mini-css-extract-plugin
var _1 = "V04DYTp_9sp0T6HUwQ9D";
var _2 = "zGEsY5c9KNXBJySDwNsu";
export { _1 as "description", _2 as "title" }
export default { "description": _1, "title": _2 }
